import { Provider, documentLang } from '@CS/components/TranslationProvider';
import type { ProviderChildren as Children, Langs } from './types';
import { DEFAULT_LANG } from './';

type ProviderProps = {
  children: Children;
  lang?: Langs;
};

export const TranslationProvider = ({
  children,
  lang: defaultLang
}: ProviderProps) => (
  <Provider value={documentLang() ?? defaultLang ?? DEFAULT_LANG}>
    {children}
  </Provider>
);
